"use strict";function unbind$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.unbind$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.iot.unbind";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.6.34"},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.6.34"},_a)),exports.unbind$=unbind$,exports.default=unbind$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/iot/unbind.js
// module id = 961
// module chunks = 106